module.exports = __webpack_public_path__ + "static/media/providerGoldTop1D.4d895818.webp";